<template><div><h1>VUX V2.5.5 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] Add raw menu item for on-click-menu event #1772</li>
</ul>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[feature] Support hideOnBlur #1742</li>
</ul>
<h2><a href="/en/components/cell-box.html">CellBox</a></h2>
<ul><li>[change] Remove default slot's div wrapper #1769</li>
</ul>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] Add method:setInputValue #1746</li>
</ul>
<h2><a href="/en/components/countup.html">Countup</a></h2>
<ul><li>[feature] Add prop:tag for customize tag #1739</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] support prop:compute-hours-function #1749</li>
<li>[enhance] better mask transition</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] support multi select #1446 #1467</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[feature] Auto hide popup on deactived #1774</li>
</ul>
<h2><a href="/en/components/swipeout.html">Swipeout</a></h2>
<ul><li>[enhance] swipeout-item add render method #1688</li>
</ul>
<h2><a href="/en/components/tabbar.html">Tabbar</a></h2>
<ul><li>[feature] Support replace: true for link #1761</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[feature] Add $event param for on-focus on-blur event #1770</li>
<li>[fix] Fix empty value checking logic #1759</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.5 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.5-127.vue?ab649922